module.exports = __webpack_public_path__ + "static/media/Connect.e7c955c7.svg";